import { Table } from "antd";
import styled from "styled-components";

export const AntTable = styled(Table)``;
